
    const original = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"14\" height=\"14\" viewBox=\"0,0,14,14\"><g transform=\"translate(-233,-173)\"><g fill=\"#855cd6\" stroke=\"#855cd6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path d=\"M237.3,173.5h5.4l3.8,3.8v5.4l-3.8,3.8h-5.4l-3.8,-3.8v-5.4z\"/></g></g></svg><!--rotationCenter:7:7-->";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
